/**
 * @module M/plugin/CallejeroRest
 */
import '../assets/css/callejerorest';
import '../assets/css/fonts';
import CallejeroRestControl from './callejerorestcontrol';
import { getValue } from './i18n/language';

export default class CallejeroRest extends M.Plugin {
  /**
   * @classdesc
   * Main facade plugin object. This class creates a plugin
   * object which has an implementation Object
   *
   * @constructor
   * @extends {M.Plugin}
   * @param {Object} impl implementation object
   * @api
   */
  constructor(options) {
    super();
    /**
     * Facade of the map
     * @private
     * @type {M.Map}
     */
    this.map_ = null;

    /**
     * Array of controls
     * @private
     * @type {Array<M.Control>}
     */
    this.controls_ = [];

    /**
     * This variable indicates whether the plugin can be collapsed.
     * @private
     * @type {boolean}
     */
    this.collapsed = options.collapsed || true;

    /**
     * This variable indicates whether the plugin can be collapsible.
     * @private
     * @type {boolean}
     */
    this.collapsible = options.collapsible || true;


    /**
     * This variable indicates plugin's position on window
     * @private
     * @type {string} { 'TL' | 'TR' | 'BL' | 'BR' } (corners)
     */
    this.position = options.position || 'TL';

    /**
     * Zoom to do
     *
     * @private
     * @type {string / number}
     */
    this.zoom_ = 16;
    if (options.zoom !== undefined) {
      this.zoom_ = parseInt(options.zoom, 10);
    }
  }

  /**
   * This function adds this plugin into the map
   *
   * @public
   * @function
   * @param {M.Map} map the map to add the plugin
   * @api
   */
  addTo(map) {
    this.controls_.push(new CallejeroRestControl(this.zoom_));
    this.map_ = map;
    this.panel_ = new M.ui.Panel('panelCallejeroRest', {
      collapsible: this.collapsible,
      position: M.ui.position[this.position],
      collapsed: this.collapsed,
      className: 'callejerorest-panel',
      collapsedButtonClass: 'icon-lupa',
      tooltip: getValue('tooltip'),
    });

    this.panel_.addControls(this.controls_);
    map.addPanels(this.panel_);
  }

  /**
   * Name of the plugin
   *
   * @getter
   * @function
   */
  get name() {
    return 'callejerorest';
  }

  /**
   * Get the API REST Parameters of the plugin
   *
   * @function
   * @public
   * @api
   */
  getAPIRest() {
    return `${this.name}=${this.collapsed}*${this.collapsible}*${this.position}*${this.zoom}`;
  }

  /**
   * This function destroys this plugin
   *
   * @public
   * @function
   * @api stable
   */
  destroy() {
    this.map_.removeControls(this.controls_);
    this.map_ = null;
    this.control_ = null;
    this.controls_ = null;
    this.panel_ = null;
  }
}
